import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertController } from 'ionic-angular';

import { Observable } from 'rxjs';

import { UtilService } from './util-service';
import { UsuarioService } from './usuario-service';
import { GestaoPcaService } from './gestao-pca-service';
import { AlertService } from './alert-service';

import { saveAs } from 'file-saver';
import { FileService } from './file-service';
/*
  Generated class for the ControlesInternosService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ControlesInternosService {
  urlObterQuestoes: string;
  usuario: any;
  isJurisdicionado: any;

  constructor(http: HttpClient,
    private usuarioService: UsuarioService,
    private gestaoPcaService: GestaoPcaService,
    private alertCtrl: AlertController,
    private utilService: UtilService,
    private alertService: AlertService,
    private fileService: FileService) {
    usuarioService.getUsuario().subscribe(broadcastVariable => {
      this.usuario = broadcastVariable.usr;
      this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    });
  }

  //Obter lista com todas as questões
  public obterQuestoesPCA(): Observable<any> {
    this.urlObterQuestoes = "categoria/listar/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obter lista com questões inclusas no certificado (flag Incluir)
  public obterQuestoesCertificadoPCA(): Observable<any> {
    this.urlObterQuestoes = "questao/listarPeviewCertificado/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obtem lista com todos os tipos de respostas
  public obterTodosTiposResposta(): Observable<any> {
    this.urlObterQuestoes = "resposta/obterTodas";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterQuestionarioPreenchido(): Observable<any> {
    this.urlObterQuestoes = "questao/obterquestionario/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obtem resposta do analista por questão
  public obterRepostaAnalista(idQuestaoResposta) {
    this.urlObterQuestoes = "respostaAnalista/obter/" + idQuestaoResposta;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarQuestionarioAnalista(JsonEnviar): Observable<any> {
    this.urlObterQuestoes = "respostaAnalista/salvarTodas";
    return this.utilService.postJSON(this.urlObterQuestoes, JsonEnviar);
  }

  public submeterQuestionarioAnalista(JsonEnviar): Observable<any> {
    this.urlObterQuestoes = "respostaAnalista/submeterTodas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, JsonEnviar);
  }

  public salvarQuestionario(jsonQuestionario, flAssinatura): Observable<any> {
    let arrayQuestoes: any = [];
    this.urlObterQuestoes = "questao/salvarquestionario?idPca=" + this.gestaoPcaService.getPCA().id + "&flAssinatura=" + flAssinatura;
    jsonQuestionario.forEach(questao => {
      // categoria.perguntas.forEach(questao => {
      arrayQuestoes.push(questao);
      // });
    });
    return this.utilService.postJSON(this.urlObterQuestoes, arrayQuestoes);
  }


  /* ==========================================================
  *
  *    Métodos Para trabalhar com Arquivo de evidência
  *
  ============================================================= */
  public carregarListaArquivoEvidencia(idQuestaoResposta): Observable<any> {
    this.urlObterQuestoes = "arquivo/listarArquivosPorPergunta/" + idQuestaoResposta;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public deletarArquivoEvidencia(jsonArquivo): Observable<any> {
    this.urlObterQuestoes = "arquivo/deletarArquivo/";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonArquivo);
  }

  public downloadfile(path: string, jsonArquivo: any) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON(path)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, jsonArquivo.nmArquivo);
      },
        error => {
          console.log("Error downloading the file. error: " + error);
          this.alertService.mostraAlerta("", error.mensagem);
        });
  }

  public baixarArquivoEvidencia(jsonArquivo) {
    if (jsonArquivo.idArquivo != 0) {
      this.urlObterQuestoes = "arquivo/download?idArquivo=" + jsonArquivo.idArquivo;
      this.downloadfile(this.urlObterQuestoes, jsonArquivo);
    } else {
      this.urlObterQuestoes = "arquivo/downloadTemp?idPca=" + this.gestaoPcaService.getPCA().id + "&nmArquivo=" + jsonArquivo.nmArquivoTemp;
      this.downloadfile(this.urlObterQuestoes, jsonArquivo);
    }
  }

  public enviarArquivoEvidencia(event, idQuestao, idQuestaoResposta) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivoEvidencia', file, file.name);
      let envioRolXml: string = "arquivo/salvarArquivo?idQuestao=" + idQuestao + "&idQuestaoResposta=" + idQuestaoResposta + "&idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }


  public salvarPergunta(categoriaId, perguntaJson): Observable<any> {
    let urlObtencaoDados: string = "questao/salvarPergunta/" + categoriaId;
    return this.utilService.postJSON(urlObtencaoDados, perguntaJson);
  }


  mostraAlerta(title, subTitle) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subTitle,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  

  public salvarFormularioControleInterno(file, idModuloPca, idFormularioAnterior): Promise<any> {
    return new Promise( (resolve, reject) => {
      if (idFormularioAnterior) {
        this.excluirFormularioControleInternoAnterior(idFormularioAnterior)
           .subscribe( () => {
              this.salvarFormulario(file, idModuloPca, resolve, reject);
            }, error => reject('Erro ao excluir o formulário de autoavalicação anterior'));
      } else {
        this.salvarFormulario(file, idModuloPca, resolve, reject);
      }
    });
  }

  private salvarFormulario(file, idModuloPca, resolve, reject) {

    const idProcesso = 0;
    const tipoAnalise = 0;
    const tipoEntidadeExercicio = 0;
    const tipodocumento = 0;
    const dsOrigemArquivo = 'Formulário de Autoavaliação de Controle Interno';
    
    this.fileService.salvarPecaFile(file, idProcesso, idModuloPca, tipoAnalise, tipoEntidadeExercicio, tipodocumento, dsOrigemArquivo)
              .subscribe(arquivo => {
                resolve(arquivo)
              }, error => {
                reject('Erro ao salvar o formulário de autoavalicação');
              });
}

  private excluirFormularioControleInternoAnterior(idFormularioAnterior) {
    let urlObtencaoDados: string = "arquivo/deletar/" + idFormularioAnterior;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public getFormularioControleInterno(idPca): Observable<any> {
    return this.utilService.getJSON(`controlesinternos/obterFormularioControleInterno?idPca=${idPca}`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/controles-internos-service.ts